import { html, View } from 'rune-ts';
import klass from './Loader.module.scss';

export interface LoaderData {}

export interface LoaderOption {
  klass?: string;
}

export class Loader extends View<LoaderData> {
  constructor(
    data: LoaderData,
    public option: LoaderOption = {},
  ) {
    super(data);
  }

  override template() {
    return html`<div class="${this.option.klass ?? ''} ${klass.loader}"></div> `;
  }

  start() {
    this.render();
    document.body.appendChild(this.element());
  }

  static start(data: LoaderData = {}, option: LoaderOption = {}) {
    const loader = new Loader(data, option);
    loader.start();
  }

  static stop() {
    const loader = document.querySelector(`.${klass.loader}`);
    if (loader) {
      loader.remove();
    }
  }
}
